import { defineMessages } from "react-intl";

export default defineMessages({
  header: {
    defaultMessage: "Courses",
    id: "app.components.CoursesOverview.header",
  },
});
